import axios from 'axios'
import { config } from '@/config'
const baseUrl = `${config.external.llmApiUrl}/api/prompt`

export function elementaryDescription(concepts) {
    return axios.post(`${baseUrl}/elementary_description`, { concepts: concepts })
}
